import { Injectable } from "@angular/core";
import { PreloadingStrategy, Route } from "@angular/router";
import { Observable, EMPTY } from "rxjs";

@Injectable({ providedIn: "root" })
export class RoleBasedPreloadingStrategy implements PreloadingStrategy {

  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    const requiredRole = route.data?.["role"] as string | undefined;

    if (!requiredRole) {
      return load();
    }

    const user: string | null = localStorage.getItem("currentUser");
    const userObj = user ? JSON.parse(user) : null;
    const userRole: string | null = userObj?.role ?? null;

    if (!userRole) {
      return EMPTY;
    }

    // Match: admin routes for non-Student, student routes for Student
    if (requiredRole === "admin" && userRole !== "Student") {
      return load();
    }

    if (requiredRole === "student" && userRole === "Student") {
      return load();
    }

    return EMPTY;
  }
}
